<template>
    <div class="tour-btn-container classic">
        <shake-animate>
            <template v-slot="shakeStyle">
                <span
                    class="btn-item save"
                    @click="onFavoriteClick"
                    v-if="info.listingStatus != 'Sold'"
                    :class="[
                        hasFavor ? 'active' : '',
                        !hasFavor && shakeStyle.animate
                    ]"
                >
                    <i class="iconfont icon-heart default"></i>
                    <i class="iconfont icon-heart-fill hover"></i>
                    <span class="btn-text">{{
                        $t('md-detail-info.save')
                    }}</span>
                </span>
            </template>
        </shake-animate>
        <!-- tour button  -->
        <span
            v-for="tour in tourBtnList"
            :key="[tour.text, tour.link].join('_')"
            class="btn-item virtual-tour"
        >
            <a
                href="javascript:;"
                @click="handleTour($event, tour)"
                rel="noopener noreferrer"
            >
                <i class="iconfont" :class="tour.icon"></i>
                <span class="btn-text">{{ tour.text }}</span>
            </a>
        </span>
    </div>
</template>

<script>
import TourBtnMediaMixin from '../../tourBtnMediaPopMixin.js';
import shakeAnimate from '../../shake-animate.vue';

export default {
    mixins: [TourBtnMediaMixin],
    inject: ['onFavoriteClick'],
    data: function() {
        return {};
    },
    components: { shakeAnimate }
};
</script>
<style lang="scss">
.tour-btn-container.classic {
    display: flex;
    justify-content: flex-end;
    .btn-item {
        text-align: center;
        cursor: pointer;
        margin-right: 15px;
        color: var(--color-theme);
        width: 33.333%;
        padding-top: 8px;
        &.save {
            color: #f0454c;
            .hover {
                display: none;
            }
            &.active,
            &:hover {
                .default {
                    display: none;
                }
                .hover {
                    display: block;
                }
                .btn-text {
                    color: #191919;
                }
            }
        }
        .iconfont {
            font-size: 24px;
            display: block;
            line-height: 40px;
        }
        .btn-text {
            font-size: 14px;
            color: var(--color-disable);
            display: inline-block;
            margin-top: 9px;
        }
        &:last-child {
            margin-right: 0;
        }
    }
}
@media (max-width: 600px) {
    .tour-btn-container.classic {
        .btn-item {
            &.save {
                display: none;
            }
            .iconfont {
                font-size: 19px;
            }
            .btn-text {
                font-size: 12px;
                margin-top: 5px;
            }
            &:last-child {
            }
        }
    }
}
</style>
